export default {
  data: () => ({
    quoteToolFlag: false,
  }),
  beforeMount() {
    this.getLayoutFields(this.$options.name)
      .then((x) => {
        this.fieldConditions = x;
      })
      .catch((err) => {
        return null;
      });
  },
  mounted() {
    // this.updateLayoutFields({
    //   component: this.$options.name,
    //   refs: this.$refs,
    // });
  },
  watch: {
    // "$ld.flags.qouteTool": {
    //   deep: true,
    //   handler() {
    //     this.quoteToolFlag = this.$ld.flags.quoteTool;
    //   },
    // },
  },
};
